import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          <div>
            <Link
              to="/"
              className="font-heading text-2xl font-bold text-background-50 tracking-tight whitespace-nowrap"
            >
              gtbuy.run
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              A data-driven spreadsheet system to compare products, track prices, and optimize your online shopping experience across multiple platforms.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              Guides
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/article/what-is-gtbuy-spreadsheet"
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  What is GTBuy Spreadsheet
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  GTBuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              Categories
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">
              More Categories
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-700/30 max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} gtbuy.run. All external links open in new tabs. This site contains affiliate-style navigation to third-party platforms.
            </p>
            <p className="text-xs text-background-500">
              Data is informational only. Prices may change without notice.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}